import { Dispatch } from 'redux';

import { ReduxState } from '../../state';
import { 
  setGeolocatedCoordinates,
  setUserLocationInputs
} from '../actions';
import { getLocationAddress } from './getLocationAddress';
import { eventFlowUpdate } from '../../events/actions';

// Initiator to auto-locate device to determine location and address
export const autoLocateDevice = () => {
  return async (dispatch: Dispatch | any, getState: () => ReduxState) => {

    try {
      const { locationFlow } = getState().location;
      const { eventFlow } = getState().events;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            dispatch(setUserLocationInputs({...locationFlow, latitude, longitude }))
            dispatch(eventFlowUpdate({...eventFlow, latitude, longitude}))
            dispatch(getLocationAddress(latitude, longitude))
            dispatch(setGeolocatedCoordinates({ latitude, longitude }))
          },
          (error) => {
            console.error('Error getting location:', error.message);
          }
        );
      } else {
        console.error('Geolocation is not supported by your browser.');
      }

  } catch (error) {
      console.error('Error in auto locating device:', error);
  }
}
}